export function CreatePath2D(sx, sy, ex, ey) {
  var clippedRegion = new Path2D();
  var width = Math.abs(ex - sx);
  var height = Math.abs(ey - sy);
  clippedRegion.rect(sx, sy, width, height);
  clippedRegion.closePath();
  return clippedRegion;
}
